import {
  getInt32,
  getObject,
  getOptionalObject,
  getString,
  getOptionalString,
} from "@surya-digital/leo-ts-types";
import { RespondentName, RespondentNameDTO } from "./respondentName";
import { RespondentColumn, RespondentColumnDTO } from "../types/respondentColumn";

export interface RespondentDTO {
  id: number;
  firstName?: RespondentNameDTO | null;
  lastName?: RespondentNameDTO | null;
  emailId?: string | null;
  phoneNumber?: string | null;
  column0?: RespondentColumnDTO | null;
  column1?: RespondentColumnDTO | null;
  column2?: RespondentColumnDTO | null;
  column3?: RespondentColumnDTO | null;
  column4?: RespondentColumnDTO | null;
  column5?: RespondentColumnDTO | null;
  column6?: RespondentColumnDTO | null;
  column7?: RespondentColumnDTO | null;
  column8?: RespondentColumnDTO | null;
  column9?: RespondentColumnDTO | null;
  column10?: RespondentColumnDTO | null;
  column11?: RespondentColumnDTO | null;
  column12?: RespondentColumnDTO | null;
  column13?: RespondentColumnDTO | null;
  column14?: RespondentColumnDTO | null;
  column15?: RespondentColumnDTO | null;
  column16?: RespondentColumnDTO | null;
  column17?: RespondentColumnDTO | null;
  column18?: RespondentColumnDTO | null;
  column19?: RespondentColumnDTO | null;
  column20?: RespondentColumnDTO | null;
  column21?: RespondentColumnDTO | null;
  column22?: RespondentColumnDTO | null;
  column23?: RespondentColumnDTO | null;
  column24?: RespondentColumnDTO | null;
  column25?: RespondentColumnDTO | null;
  column26?: RespondentColumnDTO | null;
  column27?: RespondentColumnDTO | null;
  column28?: RespondentColumnDTO | null;
  column29?: RespondentColumnDTO | null;
  column30?: RespondentColumnDTO | null;
  column31?: RespondentColumnDTO | null;
  column32?: RespondentColumnDTO | null;
  column33?: RespondentColumnDTO | null;
  column34?: RespondentColumnDTO | null;
  column35?: RespondentColumnDTO | null;
  column36?: RespondentColumnDTO | null;
  column37?: RespondentColumnDTO | null;
  column38?: RespondentColumnDTO | null;
  column39?: RespondentColumnDTO | null;
  column40?: RespondentColumnDTO | null;
  column41?: RespondentColumnDTO | null;
  column42?: RespondentColumnDTO | null;
  column43?: RespondentColumnDTO | null;
  column44?: RespondentColumnDTO | null;
  column45?: RespondentColumnDTO | null;
  column46?: RespondentColumnDTO | null;
  column47?: RespondentColumnDTO | null;
  column48?: RespondentColumnDTO | null;
  column49?: RespondentColumnDTO | null;
  column50?: RespondentColumnDTO | null;
  column51?: RespondentColumnDTO | null;
  column52?: RespondentColumnDTO | null;
  column53?: RespondentColumnDTO | null;
  column54?: RespondentColumnDTO | null;
  column55?: RespondentColumnDTO | null;
  column56?: RespondentColumnDTO | null;
  column57?: RespondentColumnDTO | null;
  column58?: RespondentColumnDTO | null;
  column59?: RespondentColumnDTO | null;
  column60?: RespondentColumnDTO | null;
  column61?: RespondentColumnDTO | null;
  column62?: RespondentColumnDTO | null;
  column63?: RespondentColumnDTO | null;
  column64?: RespondentColumnDTO | null;
  column65?: RespondentColumnDTO | null;
  column66?: RespondentColumnDTO | null;
  column67?: RespondentColumnDTO | null;
  column68?: RespondentColumnDTO | null;
  column69?: RespondentColumnDTO | null;
  column70?: RespondentColumnDTO | null;
  column71?: RespondentColumnDTO | null;
  column72?: RespondentColumnDTO | null;
  column73?: RespondentColumnDTO | null;
  column74?: RespondentColumnDTO | null;
  column75?: RespondentColumnDTO | null;
  column76?: RespondentColumnDTO | null;
  column77?: RespondentColumnDTO | null;
  column78?: RespondentColumnDTO | null;
  column79?: RespondentColumnDTO | null;
  column80?: RespondentColumnDTO | null;
  column81?: RespondentColumnDTO | null;
  column82?: RespondentColumnDTO | null;
  column83?: RespondentColumnDTO | null;
  column84?: RespondentColumnDTO | null;
  column85?: RespondentColumnDTO | null;
  column86?: RespondentColumnDTO | null;
  column87?: RespondentColumnDTO | null;
  column88?: RespondentColumnDTO | null;
  column89?: RespondentColumnDTO | null;
  column90?: RespondentColumnDTO | null;
  column91?: RespondentColumnDTO | null;
  column92?: RespondentColumnDTO | null;
  column93?: RespondentColumnDTO | null;
  column94?: RespondentColumnDTO | null;
  column95?: RespondentColumnDTO | null;
  column96?: RespondentColumnDTO | null;
  column97?: RespondentColumnDTO | null;
  column98?: RespondentColumnDTO | null;
  column99?: RespondentColumnDTO | null;
}

export class Respondent {
  readonly isRespondentRespondent: boolean = true;

  readonly id: number;
  readonly firstName: RespondentName | null;
  readonly lastName: RespondentName | null;
  readonly emailId: string | null;
  readonly phoneNumber: string | null;
  readonly column0: RespondentColumn | null;
  readonly column1: RespondentColumn | null;
  readonly column2: RespondentColumn | null;
  readonly column3: RespondentColumn | null;
  readonly column4: RespondentColumn | null;
  readonly column5: RespondentColumn | null;
  readonly column6: RespondentColumn | null;
  readonly column7: RespondentColumn | null;
  readonly column8: RespondentColumn | null;
  readonly column9: RespondentColumn | null;
  readonly column10: RespondentColumn | null;
  readonly column11: RespondentColumn | null;
  readonly column12: RespondentColumn | null;
  readonly column13: RespondentColumn | null;
  readonly column14: RespondentColumn | null;
  readonly column15: RespondentColumn | null;
  readonly column16: RespondentColumn | null;
  readonly column17: RespondentColumn | null;
  readonly column18: RespondentColumn | null;
  readonly column19: RespondentColumn | null;
  readonly column20: RespondentColumn | null;
  readonly column21: RespondentColumn | null;
  readonly column22: RespondentColumn | null;
  readonly column23: RespondentColumn | null;
  readonly column24: RespondentColumn | null;
  readonly column25: RespondentColumn | null;
  readonly column26: RespondentColumn | null;
  readonly column27: RespondentColumn | null;
  readonly column28: RespondentColumn | null;
  readonly column29: RespondentColumn | null;
  readonly column30: RespondentColumn | null;
  readonly column31: RespondentColumn | null;
  readonly column32: RespondentColumn | null;
  readonly column33: RespondentColumn | null;
  readonly column34: RespondentColumn | null;
  readonly column35: RespondentColumn | null;
  readonly column36: RespondentColumn | null;
  readonly column37: RespondentColumn | null;
  readonly column38: RespondentColumn | null;
  readonly column39: RespondentColumn | null;
  readonly column40: RespondentColumn | null;
  readonly column41: RespondentColumn | null;
  readonly column42: RespondentColumn | null;
  readonly column43: RespondentColumn | null;
  readonly column44: RespondentColumn | null;
  readonly column45: RespondentColumn | null;
  readonly column46: RespondentColumn | null;
  readonly column47: RespondentColumn | null;
  readonly column48: RespondentColumn | null;
  readonly column49: RespondentColumn | null;
  readonly column50: RespondentColumn | null;
  readonly column51: RespondentColumn | null;
  readonly column52: RespondentColumn | null;
  readonly column53: RespondentColumn | null;
  readonly column54: RespondentColumn | null;
  readonly column55: RespondentColumn | null;
  readonly column56: RespondentColumn | null;
  readonly column57: RespondentColumn | null;
  readonly column58: RespondentColumn | null;
  readonly column59: RespondentColumn | null;
  readonly column60: RespondentColumn | null;
  readonly column61: RespondentColumn | null;
  readonly column62: RespondentColumn | null;
  readonly column63: RespondentColumn | null;
  readonly column64: RespondentColumn | null;
  readonly column65: RespondentColumn | null;
  readonly column66: RespondentColumn | null;
  readonly column67: RespondentColumn | null;
  readonly column68: RespondentColumn | null;
  readonly column69: RespondentColumn | null;
  readonly column70: RespondentColumn | null;
  readonly column71: RespondentColumn | null;
  readonly column72: RespondentColumn | null;
  readonly column73: RespondentColumn | null;
  readonly column74: RespondentColumn | null;
  readonly column75: RespondentColumn | null;
  readonly column76: RespondentColumn | null;
  readonly column77: RespondentColumn | null;
  readonly column78: RespondentColumn | null;
  readonly column79: RespondentColumn | null;
  readonly column80: RespondentColumn | null;
  readonly column81: RespondentColumn | null;
  readonly column82: RespondentColumn | null;
  readonly column83: RespondentColumn | null;
  readonly column84: RespondentColumn | null;
  readonly column85: RespondentColumn | null;
  readonly column86: RespondentColumn | null;
  readonly column87: RespondentColumn | null;
  readonly column88: RespondentColumn | null;
  readonly column89: RespondentColumn | null;
  readonly column90: RespondentColumn | null;
  readonly column91: RespondentColumn | null;
  readonly column92: RespondentColumn | null;
  readonly column93: RespondentColumn | null;
  readonly column94: RespondentColumn | null;
  readonly column95: RespondentColumn | null;
  readonly column96: RespondentColumn | null;
  readonly column97: RespondentColumn | null;
  readonly column98: RespondentColumn | null;
  readonly column99: RespondentColumn | null;

  static readonly constraints = {
    "emailId": {
      "maxSize": 500,
      
      
      
      
    },
    "phoneNumber": {
      "maxSize": 50,
      
      
      
      
    },
  }

  constructor(
  id: number, 
  firstName: RespondentName | null = null, 
  lastName: RespondentName | null = null, 
  emailId: string | null = null, 
  phoneNumber: string | null = null, 
  column0: RespondentColumn | null = null, 
  column1: RespondentColumn | null = null, 
  column2: RespondentColumn | null = null, 
  column3: RespondentColumn | null = null, 
  column4: RespondentColumn | null = null, 
  column5: RespondentColumn | null = null, 
  column6: RespondentColumn | null = null, 
  column7: RespondentColumn | null = null, 
  column8: RespondentColumn | null = null, 
  column9: RespondentColumn | null = null, 
  column10: RespondentColumn | null = null, 
  column11: RespondentColumn | null = null, 
  column12: RespondentColumn | null = null, 
  column13: RespondentColumn | null = null, 
  column14: RespondentColumn | null = null, 
  column15: RespondentColumn | null = null, 
  column16: RespondentColumn | null = null, 
  column17: RespondentColumn | null = null, 
  column18: RespondentColumn | null = null, 
  column19: RespondentColumn | null = null, 
  column20: RespondentColumn | null = null, 
  column21: RespondentColumn | null = null, 
  column22: RespondentColumn | null = null, 
  column23: RespondentColumn | null = null, 
  column24: RespondentColumn | null = null, 
  column25: RespondentColumn | null = null, 
  column26: RespondentColumn | null = null, 
  column27: RespondentColumn | null = null, 
  column28: RespondentColumn | null = null, 
  column29: RespondentColumn | null = null, 
  column30: RespondentColumn | null = null, 
  column31: RespondentColumn | null = null, 
  column32: RespondentColumn | null = null, 
  column33: RespondentColumn | null = null, 
  column34: RespondentColumn | null = null, 
  column35: RespondentColumn | null = null, 
  column36: RespondentColumn | null = null, 
  column37: RespondentColumn | null = null, 
  column38: RespondentColumn | null = null, 
  column39: RespondentColumn | null = null, 
  column40: RespondentColumn | null = null, 
  column41: RespondentColumn | null = null, 
  column42: RespondentColumn | null = null, 
  column43: RespondentColumn | null = null, 
  column44: RespondentColumn | null = null, 
  column45: RespondentColumn | null = null, 
  column46: RespondentColumn | null = null, 
  column47: RespondentColumn | null = null, 
  column48: RespondentColumn | null = null, 
  column49: RespondentColumn | null = null, 
  column50: RespondentColumn | null = null, 
  column51: RespondentColumn | null = null, 
  column52: RespondentColumn | null = null, 
  column53: RespondentColumn | null = null, 
  column54: RespondentColumn | null = null, 
  column55: RespondentColumn | null = null, 
  column56: RespondentColumn | null = null, 
  column57: RespondentColumn | null = null, 
  column58: RespondentColumn | null = null, 
  column59: RespondentColumn | null = null, 
  column60: RespondentColumn | null = null, 
  column61: RespondentColumn | null = null, 
  column62: RespondentColumn | null = null, 
  column63: RespondentColumn | null = null, 
  column64: RespondentColumn | null = null, 
  column65: RespondentColumn | null = null, 
  column66: RespondentColumn | null = null, 
  column67: RespondentColumn | null = null, 
  column68: RespondentColumn | null = null, 
  column69: RespondentColumn | null = null, 
  column70: RespondentColumn | null = null, 
  column71: RespondentColumn | null = null, 
  column72: RespondentColumn | null = null, 
  column73: RespondentColumn | null = null, 
  column74: RespondentColumn | null = null, 
  column75: RespondentColumn | null = null, 
  column76: RespondentColumn | null = null, 
  column77: RespondentColumn | null = null, 
  column78: RespondentColumn | null = null, 
  column79: RespondentColumn | null = null, 
  column80: RespondentColumn | null = null, 
  column81: RespondentColumn | null = null, 
  column82: RespondentColumn | null = null, 
  column83: RespondentColumn | null = null, 
  column84: RespondentColumn | null = null, 
  column85: RespondentColumn | null = null, 
  column86: RespondentColumn | null = null, 
  column87: RespondentColumn | null = null, 
  column88: RespondentColumn | null = null, 
  column89: RespondentColumn | null = null, 
  column90: RespondentColumn | null = null, 
  column91: RespondentColumn | null = null, 
  column92: RespondentColumn | null = null, 
  column93: RespondentColumn | null = null, 
  column94: RespondentColumn | null = null, 
  column95: RespondentColumn | null = null, 
  column96: RespondentColumn | null = null, 
  column97: RespondentColumn | null = null, 
  column98: RespondentColumn | null = null, 
  column99: RespondentColumn | null = null
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    if ( emailId !== undefined && emailId !== null) {
      Respondent.validateEmailId(emailId);
    }
    this.emailId = emailId;
    if ( phoneNumber !== undefined && phoneNumber !== null) {
      Respondent.validatePhoneNumber(phoneNumber);
    }
    this.phoneNumber = phoneNumber;
    this.column0 = column0;
    this.column1 = column1;
    this.column2 = column2;
    this.column3 = column3;
    this.column4 = column4;
    this.column5 = column5;
    this.column6 = column6;
    this.column7 = column7;
    this.column8 = column8;
    this.column9 = column9;
    this.column10 = column10;
    this.column11 = column11;
    this.column12 = column12;
    this.column13 = column13;
    this.column14 = column14;
    this.column15 = column15;
    this.column16 = column16;
    this.column17 = column17;
    this.column18 = column18;
    this.column19 = column19;
    this.column20 = column20;
    this.column21 = column21;
    this.column22 = column22;
    this.column23 = column23;
    this.column24 = column24;
    this.column25 = column25;
    this.column26 = column26;
    this.column27 = column27;
    this.column28 = column28;
    this.column29 = column29;
    this.column30 = column30;
    this.column31 = column31;
    this.column32 = column32;
    this.column33 = column33;
    this.column34 = column34;
    this.column35 = column35;
    this.column36 = column36;
    this.column37 = column37;
    this.column38 = column38;
    this.column39 = column39;
    this.column40 = column40;
    this.column41 = column41;
    this.column42 = column42;
    this.column43 = column43;
    this.column44 = column44;
    this.column45 = column45;
    this.column46 = column46;
    this.column47 = column47;
    this.column48 = column48;
    this.column49 = column49;
    this.column50 = column50;
    this.column51 = column51;
    this.column52 = column52;
    this.column53 = column53;
    this.column54 = column54;
    this.column55 = column55;
    this.column56 = column56;
    this.column57 = column57;
    this.column58 = column58;
    this.column59 = column59;
    this.column60 = column60;
    this.column61 = column61;
    this.column62 = column62;
    this.column63 = column63;
    this.column64 = column64;
    this.column65 = column65;
    this.column66 = column66;
    this.column67 = column67;
    this.column68 = column68;
    this.column69 = column69;
    this.column70 = column70;
    this.column71 = column71;
    this.column72 = column72;
    this.column73 = column73;
    this.column74 = column74;
    this.column75 = column75;
    this.column76 = column76;
    this.column77 = column77;
    this.column78 = column78;
    this.column79 = column79;
    this.column80 = column80;
    this.column81 = column81;
    this.column82 = column82;
    this.column83 = column83;
    this.column84 = column84;
    this.column85 = column85;
    this.column86 = column86;
    this.column87 = column87;
    this.column88 = column88;
    this.column89 = column89;
    this.column90 = column90;
    this.column91 = column91;
    this.column92 = column92;
    this.column93 = column93;
    this.column94 = column94;
    this.column95 = column95;
    this.column96 = column96;
    this.column97 = column97;
    this.column98 = column98;
    this.column99 = column99;
  }

  static fromDTO(dto: RespondentDTO): Respondent {
    const id = getInt32(dto, "id", InvalidRespondentIdError);
    let firstName = getOptionalObject(dto, "firstName");
    if(firstName !== undefined && firstName !== null) {
      firstName = RespondentName.fromDTO(getObject(dto, "firstName", InvalidRespondentFirstNameError));
    }
    let lastName = getOptionalObject(dto, "lastName");
    if(lastName !== undefined && lastName !== null) {
      lastName = RespondentName.fromDTO(getObject(dto, "lastName", InvalidRespondentLastNameError));
    }
    const emailId = getOptionalString(dto, "emailId", InvalidRespondentEmailIdError);
    const phoneNumber = getOptionalString(dto, "phoneNumber", InvalidRespondentPhoneNumberError);
    let column0 = getOptionalObject(dto, "column0");
    if(column0 !== undefined && column0 !== null) {
      column0 = RespondentColumn.fromDTO(getObject(dto, "column0", InvalidRespondentColumn0Error));
    }
    let column1 = getOptionalObject(dto, "column1");
    if(column1 !== undefined && column1 !== null) {
      column1 = RespondentColumn.fromDTO(getObject(dto, "column1", InvalidRespondentColumn1Error));
    }
    let column2 = getOptionalObject(dto, "column2");
    if(column2 !== undefined && column2 !== null) {
      column2 = RespondentColumn.fromDTO(getObject(dto, "column2", InvalidRespondentColumn2Error));
    }
    let column3 = getOptionalObject(dto, "column3");
    if(column3 !== undefined && column3 !== null) {
      column3 = RespondentColumn.fromDTO(getObject(dto, "column3", InvalidRespondentColumn3Error));
    }
    let column4 = getOptionalObject(dto, "column4");
    if(column4 !== undefined && column4 !== null) {
      column4 = RespondentColumn.fromDTO(getObject(dto, "column4", InvalidRespondentColumn4Error));
    }
    let column5 = getOptionalObject(dto, "column5");
    if(column5 !== undefined && column5 !== null) {
      column5 = RespondentColumn.fromDTO(getObject(dto, "column5", InvalidRespondentColumn5Error));
    }
    let column6 = getOptionalObject(dto, "column6");
    if(column6 !== undefined && column6 !== null) {
      column6 = RespondentColumn.fromDTO(getObject(dto, "column6", InvalidRespondentColumn6Error));
    }
    let column7 = getOptionalObject(dto, "column7");
    if(column7 !== undefined && column7 !== null) {
      column7 = RespondentColumn.fromDTO(getObject(dto, "column7", InvalidRespondentColumn7Error));
    }
    let column8 = getOptionalObject(dto, "column8");
    if(column8 !== undefined && column8 !== null) {
      column8 = RespondentColumn.fromDTO(getObject(dto, "column8", InvalidRespondentColumn8Error));
    }
    let column9 = getOptionalObject(dto, "column9");
    if(column9 !== undefined && column9 !== null) {
      column9 = RespondentColumn.fromDTO(getObject(dto, "column9", InvalidRespondentColumn9Error));
    }
    let column10 = getOptionalObject(dto, "column10");
    if(column10 !== undefined && column10 !== null) {
      column10 = RespondentColumn.fromDTO(getObject(dto, "column10", InvalidRespondentColumn10Error));
    }
    let column11 = getOptionalObject(dto, "column11");
    if(column11 !== undefined && column11 !== null) {
      column11 = RespondentColumn.fromDTO(getObject(dto, "column11", InvalidRespondentColumn11Error));
    }
    let column12 = getOptionalObject(dto, "column12");
    if(column12 !== undefined && column12 !== null) {
      column12 = RespondentColumn.fromDTO(getObject(dto, "column12", InvalidRespondentColumn12Error));
    }
    let column13 = getOptionalObject(dto, "column13");
    if(column13 !== undefined && column13 !== null) {
      column13 = RespondentColumn.fromDTO(getObject(dto, "column13", InvalidRespondentColumn13Error));
    }
    let column14 = getOptionalObject(dto, "column14");
    if(column14 !== undefined && column14 !== null) {
      column14 = RespondentColumn.fromDTO(getObject(dto, "column14", InvalidRespondentColumn14Error));
    }
    let column15 = getOptionalObject(dto, "column15");
    if(column15 !== undefined && column15 !== null) {
      column15 = RespondentColumn.fromDTO(getObject(dto, "column15", InvalidRespondentColumn15Error));
    }
    let column16 = getOptionalObject(dto, "column16");
    if(column16 !== undefined && column16 !== null) {
      column16 = RespondentColumn.fromDTO(getObject(dto, "column16", InvalidRespondentColumn16Error));
    }
    let column17 = getOptionalObject(dto, "column17");
    if(column17 !== undefined && column17 !== null) {
      column17 = RespondentColumn.fromDTO(getObject(dto, "column17", InvalidRespondentColumn17Error));
    }
    let column18 = getOptionalObject(dto, "column18");
    if(column18 !== undefined && column18 !== null) {
      column18 = RespondentColumn.fromDTO(getObject(dto, "column18", InvalidRespondentColumn18Error));
    }
    let column19 = getOptionalObject(dto, "column19");
    if(column19 !== undefined && column19 !== null) {
      column19 = RespondentColumn.fromDTO(getObject(dto, "column19", InvalidRespondentColumn19Error));
    }
    let column20 = getOptionalObject(dto, "column20");
    if(column20 !== undefined && column20 !== null) {
      column20 = RespondentColumn.fromDTO(getObject(dto, "column20", InvalidRespondentColumn20Error));
    }
    let column21 = getOptionalObject(dto, "column21");
    if(column21 !== undefined && column21 !== null) {
      column21 = RespondentColumn.fromDTO(getObject(dto, "column21", InvalidRespondentColumn21Error));
    }
    let column22 = getOptionalObject(dto, "column22");
    if(column22 !== undefined && column22 !== null) {
      column22 = RespondentColumn.fromDTO(getObject(dto, "column22", InvalidRespondentColumn22Error));
    }
    let column23 = getOptionalObject(dto, "column23");
    if(column23 !== undefined && column23 !== null) {
      column23 = RespondentColumn.fromDTO(getObject(dto, "column23", InvalidRespondentColumn23Error));
    }
    let column24 = getOptionalObject(dto, "column24");
    if(column24 !== undefined && column24 !== null) {
      column24 = RespondentColumn.fromDTO(getObject(dto, "column24", InvalidRespondentColumn24Error));
    }
    let column25 = getOptionalObject(dto, "column25");
    if(column25 !== undefined && column25 !== null) {
      column25 = RespondentColumn.fromDTO(getObject(dto, "column25", InvalidRespondentColumn25Error));
    }
    let column26 = getOptionalObject(dto, "column26");
    if(column26 !== undefined && column26 !== null) {
      column26 = RespondentColumn.fromDTO(getObject(dto, "column26", InvalidRespondentColumn26Error));
    }
    let column27 = getOptionalObject(dto, "column27");
    if(column27 !== undefined && column27 !== null) {
      column27 = RespondentColumn.fromDTO(getObject(dto, "column27", InvalidRespondentColumn27Error));
    }
    let column28 = getOptionalObject(dto, "column28");
    if(column28 !== undefined && column28 !== null) {
      column28 = RespondentColumn.fromDTO(getObject(dto, "column28", InvalidRespondentColumn28Error));
    }
    let column29 = getOptionalObject(dto, "column29");
    if(column29 !== undefined && column29 !== null) {
      column29 = RespondentColumn.fromDTO(getObject(dto, "column29", InvalidRespondentColumn29Error));
    }
    let column30 = getOptionalObject(dto, "column30");
    if(column30 !== undefined && column30 !== null) {
      column30 = RespondentColumn.fromDTO(getObject(dto, "column30", InvalidRespondentColumn30Error));
    }
    let column31 = getOptionalObject(dto, "column31");
    if(column31 !== undefined && column31 !== null) {
      column31 = RespondentColumn.fromDTO(getObject(dto, "column31", InvalidRespondentColumn31Error));
    }
    let column32 = getOptionalObject(dto, "column32");
    if(column32 !== undefined && column32 !== null) {
      column32 = RespondentColumn.fromDTO(getObject(dto, "column32", InvalidRespondentColumn32Error));
    }
    let column33 = getOptionalObject(dto, "column33");
    if(column33 !== undefined && column33 !== null) {
      column33 = RespondentColumn.fromDTO(getObject(dto, "column33", InvalidRespondentColumn33Error));
    }
    let column34 = getOptionalObject(dto, "column34");
    if(column34 !== undefined && column34 !== null) {
      column34 = RespondentColumn.fromDTO(getObject(dto, "column34", InvalidRespondentColumn34Error));
    }
    let column35 = getOptionalObject(dto, "column35");
    if(column35 !== undefined && column35 !== null) {
      column35 = RespondentColumn.fromDTO(getObject(dto, "column35", InvalidRespondentColumn35Error));
    }
    let column36 = getOptionalObject(dto, "column36");
    if(column36 !== undefined && column36 !== null) {
      column36 = RespondentColumn.fromDTO(getObject(dto, "column36", InvalidRespondentColumn36Error));
    }
    let column37 = getOptionalObject(dto, "column37");
    if(column37 !== undefined && column37 !== null) {
      column37 = RespondentColumn.fromDTO(getObject(dto, "column37", InvalidRespondentColumn37Error));
    }
    let column38 = getOptionalObject(dto, "column38");
    if(column38 !== undefined && column38 !== null) {
      column38 = RespondentColumn.fromDTO(getObject(dto, "column38", InvalidRespondentColumn38Error));
    }
    let column39 = getOptionalObject(dto, "column39");
    if(column39 !== undefined && column39 !== null) {
      column39 = RespondentColumn.fromDTO(getObject(dto, "column39", InvalidRespondentColumn39Error));
    }
    let column40 = getOptionalObject(dto, "column40");
    if(column40 !== undefined && column40 !== null) {
      column40 = RespondentColumn.fromDTO(getObject(dto, "column40", InvalidRespondentColumn40Error));
    }
    let column41 = getOptionalObject(dto, "column41");
    if(column41 !== undefined && column41 !== null) {
      column41 = RespondentColumn.fromDTO(getObject(dto, "column41", InvalidRespondentColumn41Error));
    }
    let column42 = getOptionalObject(dto, "column42");
    if(column42 !== undefined && column42 !== null) {
      column42 = RespondentColumn.fromDTO(getObject(dto, "column42", InvalidRespondentColumn42Error));
    }
    let column43 = getOptionalObject(dto, "column43");
    if(column43 !== undefined && column43 !== null) {
      column43 = RespondentColumn.fromDTO(getObject(dto, "column43", InvalidRespondentColumn43Error));
    }
    let column44 = getOptionalObject(dto, "column44");
    if(column44 !== undefined && column44 !== null) {
      column44 = RespondentColumn.fromDTO(getObject(dto, "column44", InvalidRespondentColumn44Error));
    }
    let column45 = getOptionalObject(dto, "column45");
    if(column45 !== undefined && column45 !== null) {
      column45 = RespondentColumn.fromDTO(getObject(dto, "column45", InvalidRespondentColumn45Error));
    }
    let column46 = getOptionalObject(dto, "column46");
    if(column46 !== undefined && column46 !== null) {
      column46 = RespondentColumn.fromDTO(getObject(dto, "column46", InvalidRespondentColumn46Error));
    }
    let column47 = getOptionalObject(dto, "column47");
    if(column47 !== undefined && column47 !== null) {
      column47 = RespondentColumn.fromDTO(getObject(dto, "column47", InvalidRespondentColumn47Error));
    }
    let column48 = getOptionalObject(dto, "column48");
    if(column48 !== undefined && column48 !== null) {
      column48 = RespondentColumn.fromDTO(getObject(dto, "column48", InvalidRespondentColumn48Error));
    }
    let column49 = getOptionalObject(dto, "column49");
    if(column49 !== undefined && column49 !== null) {
      column49 = RespondentColumn.fromDTO(getObject(dto, "column49", InvalidRespondentColumn49Error));
    }
    let column50 = getOptionalObject(dto, "column50");
    if(column50 !== undefined && column50 !== null) {
      column50 = RespondentColumn.fromDTO(getObject(dto, "column50", InvalidRespondentColumn50Error));
    }
    let column51 = getOptionalObject(dto, "column51");
    if(column51 !== undefined && column51 !== null) {
      column51 = RespondentColumn.fromDTO(getObject(dto, "column51", InvalidRespondentColumn51Error));
    }
    let column52 = getOptionalObject(dto, "column52");
    if(column52 !== undefined && column52 !== null) {
      column52 = RespondentColumn.fromDTO(getObject(dto, "column52", InvalidRespondentColumn52Error));
    }
    let column53 = getOptionalObject(dto, "column53");
    if(column53 !== undefined && column53 !== null) {
      column53 = RespondentColumn.fromDTO(getObject(dto, "column53", InvalidRespondentColumn53Error));
    }
    let column54 = getOptionalObject(dto, "column54");
    if(column54 !== undefined && column54 !== null) {
      column54 = RespondentColumn.fromDTO(getObject(dto, "column54", InvalidRespondentColumn54Error));
    }
    let column55 = getOptionalObject(dto, "column55");
    if(column55 !== undefined && column55 !== null) {
      column55 = RespondentColumn.fromDTO(getObject(dto, "column55", InvalidRespondentColumn55Error));
    }
    let column56 = getOptionalObject(dto, "column56");
    if(column56 !== undefined && column56 !== null) {
      column56 = RespondentColumn.fromDTO(getObject(dto, "column56", InvalidRespondentColumn56Error));
    }
    let column57 = getOptionalObject(dto, "column57");
    if(column57 !== undefined && column57 !== null) {
      column57 = RespondentColumn.fromDTO(getObject(dto, "column57", InvalidRespondentColumn57Error));
    }
    let column58 = getOptionalObject(dto, "column58");
    if(column58 !== undefined && column58 !== null) {
      column58 = RespondentColumn.fromDTO(getObject(dto, "column58", InvalidRespondentColumn58Error));
    }
    let column59 = getOptionalObject(dto, "column59");
    if(column59 !== undefined && column59 !== null) {
      column59 = RespondentColumn.fromDTO(getObject(dto, "column59", InvalidRespondentColumn59Error));
    }
    let column60 = getOptionalObject(dto, "column60");
    if(column60 !== undefined && column60 !== null) {
      column60 = RespondentColumn.fromDTO(getObject(dto, "column60", InvalidRespondentColumn60Error));
    }
    let column61 = getOptionalObject(dto, "column61");
    if(column61 !== undefined && column61 !== null) {
      column61 = RespondentColumn.fromDTO(getObject(dto, "column61", InvalidRespondentColumn61Error));
    }
    let column62 = getOptionalObject(dto, "column62");
    if(column62 !== undefined && column62 !== null) {
      column62 = RespondentColumn.fromDTO(getObject(dto, "column62", InvalidRespondentColumn62Error));
    }
    let column63 = getOptionalObject(dto, "column63");
    if(column63 !== undefined && column63 !== null) {
      column63 = RespondentColumn.fromDTO(getObject(dto, "column63", InvalidRespondentColumn63Error));
    }
    let column64 = getOptionalObject(dto, "column64");
    if(column64 !== undefined && column64 !== null) {
      column64 = RespondentColumn.fromDTO(getObject(dto, "column64", InvalidRespondentColumn64Error));
    }
    let column65 = getOptionalObject(dto, "column65");
    if(column65 !== undefined && column65 !== null) {
      column65 = RespondentColumn.fromDTO(getObject(dto, "column65", InvalidRespondentColumn65Error));
    }
    let column66 = getOptionalObject(dto, "column66");
    if(column66 !== undefined && column66 !== null) {
      column66 = RespondentColumn.fromDTO(getObject(dto, "column66", InvalidRespondentColumn66Error));
    }
    let column67 = getOptionalObject(dto, "column67");
    if(column67 !== undefined && column67 !== null) {
      column67 = RespondentColumn.fromDTO(getObject(dto, "column67", InvalidRespondentColumn67Error));
    }
    let column68 = getOptionalObject(dto, "column68");
    if(column68 !== undefined && column68 !== null) {
      column68 = RespondentColumn.fromDTO(getObject(dto, "column68", InvalidRespondentColumn68Error));
    }
    let column69 = getOptionalObject(dto, "column69");
    if(column69 !== undefined && column69 !== null) {
      column69 = RespondentColumn.fromDTO(getObject(dto, "column69", InvalidRespondentColumn69Error));
    }
    let column70 = getOptionalObject(dto, "column70");
    if(column70 !== undefined && column70 !== null) {
      column70 = RespondentColumn.fromDTO(getObject(dto, "column70", InvalidRespondentColumn70Error));
    }
    let column71 = getOptionalObject(dto, "column71");
    if(column71 !== undefined && column71 !== null) {
      column71 = RespondentColumn.fromDTO(getObject(dto, "column71", InvalidRespondentColumn71Error));
    }
    let column72 = getOptionalObject(dto, "column72");
    if(column72 !== undefined && column72 !== null) {
      column72 = RespondentColumn.fromDTO(getObject(dto, "column72", InvalidRespondentColumn72Error));
    }
    let column73 = getOptionalObject(dto, "column73");
    if(column73 !== undefined && column73 !== null) {
      column73 = RespondentColumn.fromDTO(getObject(dto, "column73", InvalidRespondentColumn73Error));
    }
    let column74 = getOptionalObject(dto, "column74");
    if(column74 !== undefined && column74 !== null) {
      column74 = RespondentColumn.fromDTO(getObject(dto, "column74", InvalidRespondentColumn74Error));
    }
    let column75 = getOptionalObject(dto, "column75");
    if(column75 !== undefined && column75 !== null) {
      column75 = RespondentColumn.fromDTO(getObject(dto, "column75", InvalidRespondentColumn75Error));
    }
    let column76 = getOptionalObject(dto, "column76");
    if(column76 !== undefined && column76 !== null) {
      column76 = RespondentColumn.fromDTO(getObject(dto, "column76", InvalidRespondentColumn76Error));
    }
    let column77 = getOptionalObject(dto, "column77");
    if(column77 !== undefined && column77 !== null) {
      column77 = RespondentColumn.fromDTO(getObject(dto, "column77", InvalidRespondentColumn77Error));
    }
    let column78 = getOptionalObject(dto, "column78");
    if(column78 !== undefined && column78 !== null) {
      column78 = RespondentColumn.fromDTO(getObject(dto, "column78", InvalidRespondentColumn78Error));
    }
    let column79 = getOptionalObject(dto, "column79");
    if(column79 !== undefined && column79 !== null) {
      column79 = RespondentColumn.fromDTO(getObject(dto, "column79", InvalidRespondentColumn79Error));
    }
    let column80 = getOptionalObject(dto, "column80");
    if(column80 !== undefined && column80 !== null) {
      column80 = RespondentColumn.fromDTO(getObject(dto, "column80", InvalidRespondentColumn80Error));
    }
    let column81 = getOptionalObject(dto, "column81");
    if(column81 !== undefined && column81 !== null) {
      column81 = RespondentColumn.fromDTO(getObject(dto, "column81", InvalidRespondentColumn81Error));
    }
    let column82 = getOptionalObject(dto, "column82");
    if(column82 !== undefined && column82 !== null) {
      column82 = RespondentColumn.fromDTO(getObject(dto, "column82", InvalidRespondentColumn82Error));
    }
    let column83 = getOptionalObject(dto, "column83");
    if(column83 !== undefined && column83 !== null) {
      column83 = RespondentColumn.fromDTO(getObject(dto, "column83", InvalidRespondentColumn83Error));
    }
    let column84 = getOptionalObject(dto, "column84");
    if(column84 !== undefined && column84 !== null) {
      column84 = RespondentColumn.fromDTO(getObject(dto, "column84", InvalidRespondentColumn84Error));
    }
    let column85 = getOptionalObject(dto, "column85");
    if(column85 !== undefined && column85 !== null) {
      column85 = RespondentColumn.fromDTO(getObject(dto, "column85", InvalidRespondentColumn85Error));
    }
    let column86 = getOptionalObject(dto, "column86");
    if(column86 !== undefined && column86 !== null) {
      column86 = RespondentColumn.fromDTO(getObject(dto, "column86", InvalidRespondentColumn86Error));
    }
    let column87 = getOptionalObject(dto, "column87");
    if(column87 !== undefined && column87 !== null) {
      column87 = RespondentColumn.fromDTO(getObject(dto, "column87", InvalidRespondentColumn87Error));
    }
    let column88 = getOptionalObject(dto, "column88");
    if(column88 !== undefined && column88 !== null) {
      column88 = RespondentColumn.fromDTO(getObject(dto, "column88", InvalidRespondentColumn88Error));
    }
    let column89 = getOptionalObject(dto, "column89");
    if(column89 !== undefined && column89 !== null) {
      column89 = RespondentColumn.fromDTO(getObject(dto, "column89", InvalidRespondentColumn89Error));
    }
    let column90 = getOptionalObject(dto, "column90");
    if(column90 !== undefined && column90 !== null) {
      column90 = RespondentColumn.fromDTO(getObject(dto, "column90", InvalidRespondentColumn90Error));
    }
    let column91 = getOptionalObject(dto, "column91");
    if(column91 !== undefined && column91 !== null) {
      column91 = RespondentColumn.fromDTO(getObject(dto, "column91", InvalidRespondentColumn91Error));
    }
    let column92 = getOptionalObject(dto, "column92");
    if(column92 !== undefined && column92 !== null) {
      column92 = RespondentColumn.fromDTO(getObject(dto, "column92", InvalidRespondentColumn92Error));
    }
    let column93 = getOptionalObject(dto, "column93");
    if(column93 !== undefined && column93 !== null) {
      column93 = RespondentColumn.fromDTO(getObject(dto, "column93", InvalidRespondentColumn93Error));
    }
    let column94 = getOptionalObject(dto, "column94");
    if(column94 !== undefined && column94 !== null) {
      column94 = RespondentColumn.fromDTO(getObject(dto, "column94", InvalidRespondentColumn94Error));
    }
    let column95 = getOptionalObject(dto, "column95");
    if(column95 !== undefined && column95 !== null) {
      column95 = RespondentColumn.fromDTO(getObject(dto, "column95", InvalidRespondentColumn95Error));
    }
    let column96 = getOptionalObject(dto, "column96");
    if(column96 !== undefined && column96 !== null) {
      column96 = RespondentColumn.fromDTO(getObject(dto, "column96", InvalidRespondentColumn96Error));
    }
    let column97 = getOptionalObject(dto, "column97");
    if(column97 !== undefined && column97 !== null) {
      column97 = RespondentColumn.fromDTO(getObject(dto, "column97", InvalidRespondentColumn97Error));
    }
    let column98 = getOptionalObject(dto, "column98");
    if(column98 !== undefined && column98 !== null) {
      column98 = RespondentColumn.fromDTO(getObject(dto, "column98", InvalidRespondentColumn98Error));
    }
    let column99 = getOptionalObject(dto, "column99");
    if(column99 !== undefined && column99 !== null) {
      column99 = RespondentColumn.fromDTO(getObject(dto, "column99", InvalidRespondentColumn99Error));
    }
    return new Respondent(
      id,
      firstName,
      lastName,
      emailId,
      phoneNumber,
      column0,
      column1,
      column2,
      column3,
      column4,
      column5,
      column6,
      column7,
      column8,
      column9,
      column10,
      column11,
      column12,
      column13,
      column14,
      column15,
      column16,
      column17,
      column18,
      column19,
      column20,
      column21,
      column22,
      column23,
      column24,
      column25,
      column26,
      column27,
      column28,
      column29,
      column30,
      column31,
      column32,
      column33,
      column34,
      column35,
      column36,
      column37,
      column38,
      column39,
      column40,
      column41,
      column42,
      column43,
      column44,
      column45,
      column46,
      column47,
      column48,
      column49,
      column50,
      column51,
      column52,
      column53,
      column54,
      column55,
      column56,
      column57,
      column58,
      column59,
      column60,
      column61,
      column62,
      column63,
      column64,
      column65,
      column66,
      column67,
      column68,
      column69,
      column70,
      column71,
      column72,
      column73,
      column74,
      column75,
      column76,
      column77,
      column78,
      column79,
      column80,
      column81,
      column82,
      column83,
      column84,
      column85,
      column86,
      column87,
      column88,
      column89,
      column90,
      column91,
      column92,
      column93,
      column94,
      column95,
      column96,
      column97,
      column98,
      column99
    );
  }

  toDTO(): RespondentDTO {
    const dto: RespondentDTO = {
        id: this.id,
    };
    if (this.firstName !== undefined && this.firstName !== null){
      dto.firstName = this.firstName.toDTO();
    }
    if (this.lastName !== undefined && this.lastName !== null){
      dto.lastName = this.lastName.toDTO();
    }
    if (this.emailId !== undefined && this.emailId !== null){
      dto.emailId = this.emailId;
    }
    if (this.phoneNumber !== undefined && this.phoneNumber !== null){
      dto.phoneNumber = this.phoneNumber;
    }
    if (this.column0 !== undefined && this.column0 !== null){
      dto.column0 = this.column0.toDTO();
    }
    if (this.column1 !== undefined && this.column1 !== null){
      dto.column1 = this.column1.toDTO();
    }
    if (this.column2 !== undefined && this.column2 !== null){
      dto.column2 = this.column2.toDTO();
    }
    if (this.column3 !== undefined && this.column3 !== null){
      dto.column3 = this.column3.toDTO();
    }
    if (this.column4 !== undefined && this.column4 !== null){
      dto.column4 = this.column4.toDTO();
    }
    if (this.column5 !== undefined && this.column5 !== null){
      dto.column5 = this.column5.toDTO();
    }
    if (this.column6 !== undefined && this.column6 !== null){
      dto.column6 = this.column6.toDTO();
    }
    if (this.column7 !== undefined && this.column7 !== null){
      dto.column7 = this.column7.toDTO();
    }
    if (this.column8 !== undefined && this.column8 !== null){
      dto.column8 = this.column8.toDTO();
    }
    if (this.column9 !== undefined && this.column9 !== null){
      dto.column9 = this.column9.toDTO();
    }
    if (this.column10 !== undefined && this.column10 !== null){
      dto.column10 = this.column10.toDTO();
    }
    if (this.column11 !== undefined && this.column11 !== null){
      dto.column11 = this.column11.toDTO();
    }
    if (this.column12 !== undefined && this.column12 !== null){
      dto.column12 = this.column12.toDTO();
    }
    if (this.column13 !== undefined && this.column13 !== null){
      dto.column13 = this.column13.toDTO();
    }
    if (this.column14 !== undefined && this.column14 !== null){
      dto.column14 = this.column14.toDTO();
    }
    if (this.column15 !== undefined && this.column15 !== null){
      dto.column15 = this.column15.toDTO();
    }
    if (this.column16 !== undefined && this.column16 !== null){
      dto.column16 = this.column16.toDTO();
    }
    if (this.column17 !== undefined && this.column17 !== null){
      dto.column17 = this.column17.toDTO();
    }
    if (this.column18 !== undefined && this.column18 !== null){
      dto.column18 = this.column18.toDTO();
    }
    if (this.column19 !== undefined && this.column19 !== null){
      dto.column19 = this.column19.toDTO();
    }
    if (this.column20 !== undefined && this.column20 !== null){
      dto.column20 = this.column20.toDTO();
    }
    if (this.column21 !== undefined && this.column21 !== null){
      dto.column21 = this.column21.toDTO();
    }
    if (this.column22 !== undefined && this.column22 !== null){
      dto.column22 = this.column22.toDTO();
    }
    if (this.column23 !== undefined && this.column23 !== null){
      dto.column23 = this.column23.toDTO();
    }
    if (this.column24 !== undefined && this.column24 !== null){
      dto.column24 = this.column24.toDTO();
    }
    if (this.column25 !== undefined && this.column25 !== null){
      dto.column25 = this.column25.toDTO();
    }
    if (this.column26 !== undefined && this.column26 !== null){
      dto.column26 = this.column26.toDTO();
    }
    if (this.column27 !== undefined && this.column27 !== null){
      dto.column27 = this.column27.toDTO();
    }
    if (this.column28 !== undefined && this.column28 !== null){
      dto.column28 = this.column28.toDTO();
    }
    if (this.column29 !== undefined && this.column29 !== null){
      dto.column29 = this.column29.toDTO();
    }
    if (this.column30 !== undefined && this.column30 !== null){
      dto.column30 = this.column30.toDTO();
    }
    if (this.column31 !== undefined && this.column31 !== null){
      dto.column31 = this.column31.toDTO();
    }
    if (this.column32 !== undefined && this.column32 !== null){
      dto.column32 = this.column32.toDTO();
    }
    if (this.column33 !== undefined && this.column33 !== null){
      dto.column33 = this.column33.toDTO();
    }
    if (this.column34 !== undefined && this.column34 !== null){
      dto.column34 = this.column34.toDTO();
    }
    if (this.column35 !== undefined && this.column35 !== null){
      dto.column35 = this.column35.toDTO();
    }
    if (this.column36 !== undefined && this.column36 !== null){
      dto.column36 = this.column36.toDTO();
    }
    if (this.column37 !== undefined && this.column37 !== null){
      dto.column37 = this.column37.toDTO();
    }
    if (this.column38 !== undefined && this.column38 !== null){
      dto.column38 = this.column38.toDTO();
    }
    if (this.column39 !== undefined && this.column39 !== null){
      dto.column39 = this.column39.toDTO();
    }
    if (this.column40 !== undefined && this.column40 !== null){
      dto.column40 = this.column40.toDTO();
    }
    if (this.column41 !== undefined && this.column41 !== null){
      dto.column41 = this.column41.toDTO();
    }
    if (this.column42 !== undefined && this.column42 !== null){
      dto.column42 = this.column42.toDTO();
    }
    if (this.column43 !== undefined && this.column43 !== null){
      dto.column43 = this.column43.toDTO();
    }
    if (this.column44 !== undefined && this.column44 !== null){
      dto.column44 = this.column44.toDTO();
    }
    if (this.column45 !== undefined && this.column45 !== null){
      dto.column45 = this.column45.toDTO();
    }
    if (this.column46 !== undefined && this.column46 !== null){
      dto.column46 = this.column46.toDTO();
    }
    if (this.column47 !== undefined && this.column47 !== null){
      dto.column47 = this.column47.toDTO();
    }
    if (this.column48 !== undefined && this.column48 !== null){
      dto.column48 = this.column48.toDTO();
    }
    if (this.column49 !== undefined && this.column49 !== null){
      dto.column49 = this.column49.toDTO();
    }
    if (this.column50 !== undefined && this.column50 !== null){
      dto.column50 = this.column50.toDTO();
    }
    if (this.column51 !== undefined && this.column51 !== null){
      dto.column51 = this.column51.toDTO();
    }
    if (this.column52 !== undefined && this.column52 !== null){
      dto.column52 = this.column52.toDTO();
    }
    if (this.column53 !== undefined && this.column53 !== null){
      dto.column53 = this.column53.toDTO();
    }
    if (this.column54 !== undefined && this.column54 !== null){
      dto.column54 = this.column54.toDTO();
    }
    if (this.column55 !== undefined && this.column55 !== null){
      dto.column55 = this.column55.toDTO();
    }
    if (this.column56 !== undefined && this.column56 !== null){
      dto.column56 = this.column56.toDTO();
    }
    if (this.column57 !== undefined && this.column57 !== null){
      dto.column57 = this.column57.toDTO();
    }
    if (this.column58 !== undefined && this.column58 !== null){
      dto.column58 = this.column58.toDTO();
    }
    if (this.column59 !== undefined && this.column59 !== null){
      dto.column59 = this.column59.toDTO();
    }
    if (this.column60 !== undefined && this.column60 !== null){
      dto.column60 = this.column60.toDTO();
    }
    if (this.column61 !== undefined && this.column61 !== null){
      dto.column61 = this.column61.toDTO();
    }
    if (this.column62 !== undefined && this.column62 !== null){
      dto.column62 = this.column62.toDTO();
    }
    if (this.column63 !== undefined && this.column63 !== null){
      dto.column63 = this.column63.toDTO();
    }
    if (this.column64 !== undefined && this.column64 !== null){
      dto.column64 = this.column64.toDTO();
    }
    if (this.column65 !== undefined && this.column65 !== null){
      dto.column65 = this.column65.toDTO();
    }
    if (this.column66 !== undefined && this.column66 !== null){
      dto.column66 = this.column66.toDTO();
    }
    if (this.column67 !== undefined && this.column67 !== null){
      dto.column67 = this.column67.toDTO();
    }
    if (this.column68 !== undefined && this.column68 !== null){
      dto.column68 = this.column68.toDTO();
    }
    if (this.column69 !== undefined && this.column69 !== null){
      dto.column69 = this.column69.toDTO();
    }
    if (this.column70 !== undefined && this.column70 !== null){
      dto.column70 = this.column70.toDTO();
    }
    if (this.column71 !== undefined && this.column71 !== null){
      dto.column71 = this.column71.toDTO();
    }
    if (this.column72 !== undefined && this.column72 !== null){
      dto.column72 = this.column72.toDTO();
    }
    if (this.column73 !== undefined && this.column73 !== null){
      dto.column73 = this.column73.toDTO();
    }
    if (this.column74 !== undefined && this.column74 !== null){
      dto.column74 = this.column74.toDTO();
    }
    if (this.column75 !== undefined && this.column75 !== null){
      dto.column75 = this.column75.toDTO();
    }
    if (this.column76 !== undefined && this.column76 !== null){
      dto.column76 = this.column76.toDTO();
    }
    if (this.column77 !== undefined && this.column77 !== null){
      dto.column77 = this.column77.toDTO();
    }
    if (this.column78 !== undefined && this.column78 !== null){
      dto.column78 = this.column78.toDTO();
    }
    if (this.column79 !== undefined && this.column79 !== null){
      dto.column79 = this.column79.toDTO();
    }
    if (this.column80 !== undefined && this.column80 !== null){
      dto.column80 = this.column80.toDTO();
    }
    if (this.column81 !== undefined && this.column81 !== null){
      dto.column81 = this.column81.toDTO();
    }
    if (this.column82 !== undefined && this.column82 !== null){
      dto.column82 = this.column82.toDTO();
    }
    if (this.column83 !== undefined && this.column83 !== null){
      dto.column83 = this.column83.toDTO();
    }
    if (this.column84 !== undefined && this.column84 !== null){
      dto.column84 = this.column84.toDTO();
    }
    if (this.column85 !== undefined && this.column85 !== null){
      dto.column85 = this.column85.toDTO();
    }
    if (this.column86 !== undefined && this.column86 !== null){
      dto.column86 = this.column86.toDTO();
    }
    if (this.column87 !== undefined && this.column87 !== null){
      dto.column87 = this.column87.toDTO();
    }
    if (this.column88 !== undefined && this.column88 !== null){
      dto.column88 = this.column88.toDTO();
    }
    if (this.column89 !== undefined && this.column89 !== null){
      dto.column89 = this.column89.toDTO();
    }
    if (this.column90 !== undefined && this.column90 !== null){
      dto.column90 = this.column90.toDTO();
    }
    if (this.column91 !== undefined && this.column91 !== null){
      dto.column91 = this.column91.toDTO();
    }
    if (this.column92 !== undefined && this.column92 !== null){
      dto.column92 = this.column92.toDTO();
    }
    if (this.column93 !== undefined && this.column93 !== null){
      dto.column93 = this.column93.toDTO();
    }
    if (this.column94 !== undefined && this.column94 !== null){
      dto.column94 = this.column94.toDTO();
    }
    if (this.column95 !== undefined && this.column95 !== null){
      dto.column95 = this.column95.toDTO();
    }
    if (this.column96 !== undefined && this.column96 !== null){
      dto.column96 = this.column96.toDTO();
    }
    if (this.column97 !== undefined && this.column97 !== null){
      dto.column97 = this.column97.toDTO();
    }
    if (this.column98 !== undefined && this.column98 !== null){
      dto.column98 = this.column98.toDTO();
    }
    if (this.column99 !== undefined && this.column99 !== null){
      dto.column99 = this.column99.toDTO();
    }
    return dto;
  }
  private static validateEmailId = (emailId: string): void => {
    if(emailId.length > 500) {
      throw new InvalidRespondentEmailIdMaxSizeError(
        500,
        `Attribute emailId is too long. Size is ${emailId.length}. Max size is 500.`
      );
    }
      if(emailId.trim().length === 0) {
        throw new InvalidRespondentEmailIdNonEmptyError(
          `Attribute emailId cannot be an empty string.`
        );
      }
  }
  private static validatePhoneNumber = (phoneNumber: string): void => {
    if(phoneNumber.length > 50) {
      throw new InvalidRespondentPhoneNumberMaxSizeError(
        50,
        `Attribute phoneNumber is too long. Size is ${phoneNumber.length}. Max size is 50.`
      );
    }
      if(phoneNumber.trim().length === 0) {
        throw new InvalidRespondentPhoneNumberNonEmptyError(
          `Attribute phoneNumber cannot be an empty string.`
        );
      }
  }
  
}

Respondent.prototype.toString = function toString(): string {
  return `Respondent(id='${this.id}',firstName='${this.firstName}',lastName='${this.lastName}',emailId='${this.emailId}',phoneNumber='${this.phoneNumber}',column0='${this.column0}',column1='${this.column1}',column2='${this.column2}',column3='${this.column3}',column4='${this.column4}',column5='${this.column5}',column6='${this.column6}',column7='${this.column7}',column8='${this.column8}',column9='${this.column9}',column10='${this.column10}',column11='${this.column11}',column12='${this.column12}',column13='${this.column13}',column14='${this.column14}',column15='${this.column15}',column16='${this.column16}',column17='${this.column17}',column18='${this.column18}',column19='${this.column19}',column20='${this.column20}',column21='${this.column21}',column22='${this.column22}',column23='${this.column23}',column24='${this.column24}',column25='${this.column25}',column26='${this.column26}',column27='${this.column27}',column28='${this.column28}',column29='${this.column29}',column30='${this.column30}',column31='${this.column31}',column32='${this.column32}',column33='${this.column33}',column34='${this.column34}',column35='${this.column35}',column36='${this.column36}',column37='${this.column37}',column38='${this.column38}',column39='${this.column39}',column40='${this.column40}',column41='${this.column41}',column42='${this.column42}',column43='${this.column43}',column44='${this.column44}',column45='${this.column45}',column46='${this.column46}',column47='${this.column47}',column48='${this.column48}',column49='${this.column49}',column50='${this.column50}',column51='${this.column51}',column52='${this.column52}',column53='${this.column53}',column54='${this.column54}',column55='${this.column55}',column56='${this.column56}',column57='${this.column57}',column58='${this.column58}',column59='${this.column59}',column60='${this.column60}',column61='${this.column61}',column62='${this.column62}',column63='${this.column63}',column64='${this.column64}',column65='${this.column65}',column66='${this.column66}',column67='${this.column67}',column68='${this.column68}',column69='${this.column69}',column70='${this.column70}',column71='${this.column71}',column72='${this.column72}',column73='${this.column73}',column74='${this.column74}',column75='${this.column75}',column76='${this.column76}',column77='${this.column77}',column78='${this.column78}',column79='${this.column79}',column80='${this.column80}',column81='${this.column81}',column82='${this.column82}',column83='${this.column83}',column84='${this.column84}',column85='${this.column85}',column86='${this.column86}',column87='${this.column87}',column88='${this.column88}',column89='${this.column89}',column90='${this.column90}',column91='${this.column91}',column92='${this.column92}',column93='${this.column93}',column94='${this.column94}',column95='${this.column95}',column96='${this.column96}',column97='${this.column97}',column98='${this.column98}',column99='${this.column99}')`;
};

export class InvalidRespondentError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentError";
  }
}
export class InvalidRespondentIdError extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentIdError";
  }
}

export class InvalidRespondentFirstNameError extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentFirstNameError";
  }
}

export class InvalidRespondentLastNameError extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentLastNameError";
  }
}

export class InvalidRespondentEmailIdError extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentEmailIdError";
  }
}

export class InvalidRespondentEmailIdMaxSizeError extends InvalidRespondentEmailIdError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentEmailIdMaxSizeError";
  }
}

export class InvalidRespondentEmailIdNonEmptyError extends InvalidRespondentEmailIdError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentEmailIdNonEmptyError";
  }
}

export class InvalidRespondentPhoneNumberError extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentPhoneNumberError";
  }
}

export class InvalidRespondentPhoneNumberMaxSizeError extends InvalidRespondentPhoneNumberError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentPhoneNumberMaxSizeError";
  }
}

export class InvalidRespondentPhoneNumberNonEmptyError extends InvalidRespondentPhoneNumberError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentPhoneNumberNonEmptyError";
  }
}

export class InvalidRespondentColumn0Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn0Error";
  }
}

export class InvalidRespondentColumn1Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn1Error";
  }
}

export class InvalidRespondentColumn2Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn2Error";
  }
}

export class InvalidRespondentColumn3Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn3Error";
  }
}

export class InvalidRespondentColumn4Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn4Error";
  }
}

export class InvalidRespondentColumn5Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn5Error";
  }
}

export class InvalidRespondentColumn6Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn6Error";
  }
}

export class InvalidRespondentColumn7Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn7Error";
  }
}

export class InvalidRespondentColumn8Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn8Error";
  }
}

export class InvalidRespondentColumn9Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn9Error";
  }
}

export class InvalidRespondentColumn10Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn10Error";
  }
}

export class InvalidRespondentColumn11Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn11Error";
  }
}

export class InvalidRespondentColumn12Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn12Error";
  }
}

export class InvalidRespondentColumn13Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn13Error";
  }
}

export class InvalidRespondentColumn14Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn14Error";
  }
}

export class InvalidRespondentColumn15Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn15Error";
  }
}

export class InvalidRespondentColumn16Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn16Error";
  }
}

export class InvalidRespondentColumn17Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn17Error";
  }
}

export class InvalidRespondentColumn18Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn18Error";
  }
}

export class InvalidRespondentColumn19Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn19Error";
  }
}

export class InvalidRespondentColumn20Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn20Error";
  }
}

export class InvalidRespondentColumn21Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn21Error";
  }
}

export class InvalidRespondentColumn22Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn22Error";
  }
}

export class InvalidRespondentColumn23Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn23Error";
  }
}

export class InvalidRespondentColumn24Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn24Error";
  }
}

export class InvalidRespondentColumn25Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn25Error";
  }
}

export class InvalidRespondentColumn26Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn26Error";
  }
}

export class InvalidRespondentColumn27Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn27Error";
  }
}

export class InvalidRespondentColumn28Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn28Error";
  }
}

export class InvalidRespondentColumn29Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn29Error";
  }
}

export class InvalidRespondentColumn30Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn30Error";
  }
}

export class InvalidRespondentColumn31Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn31Error";
  }
}

export class InvalidRespondentColumn32Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn32Error";
  }
}

export class InvalidRespondentColumn33Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn33Error";
  }
}

export class InvalidRespondentColumn34Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn34Error";
  }
}

export class InvalidRespondentColumn35Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn35Error";
  }
}

export class InvalidRespondentColumn36Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn36Error";
  }
}

export class InvalidRespondentColumn37Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn37Error";
  }
}

export class InvalidRespondentColumn38Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn38Error";
  }
}

export class InvalidRespondentColumn39Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn39Error";
  }
}

export class InvalidRespondentColumn40Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn40Error";
  }
}

export class InvalidRespondentColumn41Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn41Error";
  }
}

export class InvalidRespondentColumn42Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn42Error";
  }
}

export class InvalidRespondentColumn43Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn43Error";
  }
}

export class InvalidRespondentColumn44Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn44Error";
  }
}

export class InvalidRespondentColumn45Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn45Error";
  }
}

export class InvalidRespondentColumn46Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn46Error";
  }
}

export class InvalidRespondentColumn47Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn47Error";
  }
}

export class InvalidRespondentColumn48Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn48Error";
  }
}

export class InvalidRespondentColumn49Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn49Error";
  }
}

export class InvalidRespondentColumn50Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn50Error";
  }
}

export class InvalidRespondentColumn51Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn51Error";
  }
}

export class InvalidRespondentColumn52Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn52Error";
  }
}

export class InvalidRespondentColumn53Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn53Error";
  }
}

export class InvalidRespondentColumn54Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn54Error";
  }
}

export class InvalidRespondentColumn55Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn55Error";
  }
}

export class InvalidRespondentColumn56Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn56Error";
  }
}

export class InvalidRespondentColumn57Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn57Error";
  }
}

export class InvalidRespondentColumn58Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn58Error";
  }
}

export class InvalidRespondentColumn59Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn59Error";
  }
}

export class InvalidRespondentColumn60Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn60Error";
  }
}

export class InvalidRespondentColumn61Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn61Error";
  }
}

export class InvalidRespondentColumn62Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn62Error";
  }
}

export class InvalidRespondentColumn63Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn63Error";
  }
}

export class InvalidRespondentColumn64Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn64Error";
  }
}

export class InvalidRespondentColumn65Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn65Error";
  }
}

export class InvalidRespondentColumn66Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn66Error";
  }
}

export class InvalidRespondentColumn67Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn67Error";
  }
}

export class InvalidRespondentColumn68Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn68Error";
  }
}

export class InvalidRespondentColumn69Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn69Error";
  }
}

export class InvalidRespondentColumn70Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn70Error";
  }
}

export class InvalidRespondentColumn71Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn71Error";
  }
}

export class InvalidRespondentColumn72Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn72Error";
  }
}

export class InvalidRespondentColumn73Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn73Error";
  }
}

export class InvalidRespondentColumn74Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn74Error";
  }
}

export class InvalidRespondentColumn75Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn75Error";
  }
}

export class InvalidRespondentColumn76Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn76Error";
  }
}

export class InvalidRespondentColumn77Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn77Error";
  }
}

export class InvalidRespondentColumn78Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn78Error";
  }
}

export class InvalidRespondentColumn79Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn79Error";
  }
}

export class InvalidRespondentColumn80Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn80Error";
  }
}

export class InvalidRespondentColumn81Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn81Error";
  }
}

export class InvalidRespondentColumn82Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn82Error";
  }
}

export class InvalidRespondentColumn83Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn83Error";
  }
}

export class InvalidRespondentColumn84Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn84Error";
  }
}

export class InvalidRespondentColumn85Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn85Error";
  }
}

export class InvalidRespondentColumn86Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn86Error";
  }
}

export class InvalidRespondentColumn87Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn87Error";
  }
}

export class InvalidRespondentColumn88Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn88Error";
  }
}

export class InvalidRespondentColumn89Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn89Error";
  }
}

export class InvalidRespondentColumn90Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn90Error";
  }
}

export class InvalidRespondentColumn91Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn91Error";
  }
}

export class InvalidRespondentColumn92Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn92Error";
  }
}

export class InvalidRespondentColumn93Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn93Error";
  }
}

export class InvalidRespondentColumn94Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn94Error";
  }
}

export class InvalidRespondentColumn95Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn95Error";
  }
}

export class InvalidRespondentColumn96Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn96Error";
  }
}

export class InvalidRespondentColumn97Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn97Error";
  }
}

export class InvalidRespondentColumn98Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn98Error";
  }
}

export class InvalidRespondentColumn99Error extends InvalidRespondentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumn99Error";
  }
}
